import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { MaintenanceContext } from "context/maintenanceProvider";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/saReceive/saReceiveDetail.scss";
import MaintenanceInform from "components/maintenance/maintenanceInform";
import {
  Button,
  Divider,
  Form,
  Header,
  Icon,
  Segment,
  Select,
  Table,
  TextArea,
} from "semantic-ui-react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import province from "assets/data/province.json";
import Swal from "sweetalert2";
import { DeviceContext } from "context/deviceProvider";
import { END_POINT } from "context/endPoint";
import LetterLoading from "components/loading/letterLoading";
import MaintenanceAdd from "components/maintenance/maintenanceAdd";
import { UserContext } from "context/userProvider";
import { problemOptions } from "assets/data/maintenanceOptions";

export default function SaReceiveDetail() {
  const [isLoading, setIsLoading] = useState(false);
  const [maintenanceImage, setMaintenanceImage] = useState([]);
  const [maintenanceDetail, setMaintenanceDetail] = useState({});
  const [pic, setPic] = useState([{ name: "" }]);
  const [partUseList, setPartUseList] = useState([{ partCode: "", qty: 0 }]);
  const [newPart, setNewPart] = useState([
    { partName: "", qty: "", price: "" },
  ]);
  const maintenances = useContext(MaintenanceContext);
  const devices = useContext(DeviceContext);
  const users = useContext(UserContext);
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    setMaintenanceData();
  }, []);

  const setMaintenanceData = async () => {
    await maintenances.getMaintenance({ state: [] });
    let data = await maintenances.maintenanceList.filter(
      (order) => order.documentNo === id
    );

    setMaintenanceDetail(data[0]);
    setPic(
      data[0]?.ownerEngineerList?.length > 0
        ? data[0]?.ownerEngineerList : [{ name: "" }] 
    );
    
    setMaintenanceImage(
      data[0]?.images?.handle?.length > 0 ? data[0]?.images?.handle : []
    );
    
    setPartUseList(
      data[0]?.handlePartUseList?.length > 0
        ? data[0]?.handlePartUseList
        : [{ partCode: "", qty: 0 }]
    );

    setNewPart(
      data[0]?.optionalPartList?.length > 0
        ? data[0]?.optionalPartList
        : [{ partName: "", qty: 0, price: 0 }]
    );

    await devices.getMasterParts({ model: maintenanceDetail?.model });
    setIsLoading(false);
  };

  const alertDialog = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    }).then((res) => {
      if (res.isConfirmed && icon === "success") {
        return maintenances.getMaintenance({ state: ["received"] });
      }
    });
  };

  const handleGetCost = () => {
    let priceTotal = 0;
    let partPrice = 0;
    let optionalPartPrice = 0;

    partUseList?.length > 0 &&
      partUseList.map((part) =>
        devices.partsList?.map((temp) =>
          temp.code === part.partCode ? (partPrice += temp.price * part.qty) : 0
        )
      );

    newPart.map((part) => (optionalPartPrice += part.qty * part.price));
    priceTotal = partPrice + optionalPartPrice;
    return priceTotal;
  };

  const onUpdateTime = (date) => {
    let updateDate =
      date
        .toLocaleDateString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replaceAll(". ", "-")
        .replaceAll(".", " ") + date.toTimeString().substring(0, 8);

    return updateDate;
  };

  const onUpdateMaintenance = async (button) => {
    if (
      maintenanceDetail?.handleNote == null ||
      maintenanceDetail?.handleDate == null ||
      maintenanceDetail?.provinceId == null
    ) {
      return alertDialog("Warning!", "กรุณากรอกข้อมูลให้ครบถ้วน", "warning");
    }

    const data = {
      id: maintenanceDetail.id,
      handleNote: maintenanceDetail.handleNote,
      handleDate: maintenanceDetail.handleDate,
      provinceId: maintenanceDetail.provinceId,
      handleRemark: maintenanceDetail.handleRemark,
      handlePartUseList: partUseList,
      optionalPartList: newPart,
      ownerEngineerList: pic,
      topic: maintenanceDetail.topic,

      state: button === "approve" ? "processing" : "received",
      isReturn: button === "reject" ? 1 : 0,
      workerId: "manager",
    };

    if (
      (data?.ownerEngineerList.length == 1 && data?.ownerEngineerList[0]?.name == "")
    ) {
      return alertDialog("Warning!", "กรุณากรอกข้อมูลผู้รับผิดชอบ", "warning");
    }

    console.log("EngineerList",data.ownerEngineerList)
    console.log("PartList",data.optionalPartList)
    // console.log(data);
    const formData = new FormData();
    maintenanceImage?.map((image) => formData.append("file", image));
    formData.append("data", JSON.stringify(data));

    let result = await maintenances.updateMaintenanceWithImage(formData);
    if (result?.code === 0) {
      return alertDialog("Success!", result?.description, "success");
    } else {
      return alertDialog("Error!", result?.description, "error");
    }
  };

  const onSelectImage = (e) => {
    console.log("e.target.files: " + e.target.files.length);
    if (maintenanceImage.length < 5 && e.target.files.length < 6) {
      let files = Array.from(e.target.files).map((image) => image);
      setMaintenanceImage([...maintenanceImage, ...files]);
    } else {
      alertDialog("Error!", "ไม่สามารถอัพโหลดรูปภาพได้เกิน 5 รูป", "error");
    }
  };

  const removeImage = (name) => {
    const imageFilter = maintenanceImage.filter((image) => image.name !== name);
    setMaintenanceImage(imageFilter);
  };

  const createPartUse = () => {
    const partOptions = devices.partsList.map((part) => ({
      key: part.code,
      value: part.code,
      text: part.name_th,
    }));
    // console.log(partUseList);
    console.log(maintenanceDetail);
    return (
      <>
        {/* {partUseList?.map((part, idx) => ( */}
        <div className="partUseList">
          
          <Table celled className="partUseList">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>ชื่ออะไหล่ (Item Code)</Table.HeaderCell>
                <Table.HeaderCell>จำนวน</Table.HeaderCell>
                <Table.HeaderCell>สถานะ</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {partUseList?.map((part, idx) => (
                <Table.Row key={idx}>
                  <Table.Cell>
                    <Form>
                      <Select
                        label={"ชื่ออะไหล่"}
                        options={partOptions}
                        placeholder="ชื่ออะไหล่"
                        search
                        value={part?.partCode || ""}
                        onChange={(e, { value }) => {
                          let newPartUse = partUseList;
                          newPartUse[idx]["partCode"] = value;
                          setPartUseList([...newPartUse]);
                        }}
                      />
                    </Form>
                  </Table.Cell>
                  <Table.Cell>
                    <Form>
                      <input
                        label="จำนวน"
                        type="number"
                        placeholder="จำนวน"
                        value={part?.qty || ""}
                        onChange={(e) => {
                          let newPartUse = partUseList;
                          newPartUse[idx]["qty"] = parseInt(e.target.value);
                          setPartUseList([...newPartUse]);
                        }}
                      />
                    </Form>
                  </Table.Cell>
                  <Table.Cell>
                    {idx ? (
                      <Button
                        color="red"
                        onClick={() => {
                          console.log(idx);
                          let newPartUseList = partUseList;
                          newPartUseList.splice(idx, 1);
                          setPartUseList([...newPartUseList]);
                        }}
                      >
                        ลบ
                      </Button>
                    ) : (
                      <Button
                        color="teal"
                        onClick={() =>
                          setPartUseList([
                            ...partUseList,
                            { partCode: "", qty: 0 },
                          ])
                        }
                      >
                        เพิ่ม
                      </Button>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
        {/* ))} */}
      </>
    );
  };

  const createAdditionalPart = () => {
    return (
      <>
        <div>
          <Table celled className="newPart">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>ชื่ออะไหล่ (Item Code)</Table.HeaderCell>
                <Table.HeaderCell>จำนวน</Table.HeaderCell>
                <Table.HeaderCell>ราคา</Table.HeaderCell>
                <Table.HeaderCell>สถานะ</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {newPart?.map((part, idx) => (
                <Table.Row key={idx}>
                  <Table.Cell>
                    <Form>
                      <input
                        placeholder="ชื่ออะไหล่"
                        value={part?.partName || ""}
                        onChange={(e) => {
                          let newPartUse = newPart;
                          newPartUse[idx]["partName"] = e.target.value;
                          setNewPart([...newPartUse]);
                        }}
                      />
                    </Form>
                  </Table.Cell>
                  <Table.Cell>
                    <Form>
                      <input
                        type="number"
                        placeholder="จำนวน"
                        value={part?.qty || ""}
                        onChange={(e) => {
                          let newPartUse = newPart;
                          newPartUse[idx]["qty"] = parseInt(e.target.value);
                          setNewPart([...newPartUse]);
                        }}
                      />
                    </Form>
                  </Table.Cell>
                  <Table.Cell>
                    <Form>
                      <input
                        type="number"
                        placeholder="ราคา"
                        value={part?.price || ""}
                        onChange={(e) => {
                          let newPartUse = newPart;
                          newPartUse[idx]["price"] = parseInt(e.target.value);
                          setNewPart([...newPartUse]);
                        }}
                        readOnly={
                          users.userDetail?.role !== "sc" &&
                          users.userDetail?.role !== "manager"
                        }
                      />
                    </Form>
                  </Table.Cell>
                  <Table.Cell>
                    {idx ? (
                      <Button
                        color="red"
                        onClick={() => {
                          console.log(idx);
                          let newPartUseList = newPart;
                          newPartUseList.splice(idx, 1);
                          setNewPart([...newPartUseList]);
                        }}
                      >
                        ลบ
                      </Button>
                    ) : (
                      <Button
                        color="teal"
                        onClick={() =>
                          setNewPart([
                            ...newPart,
                            { partName: "", qty: 0, price: 0 },
                          ])
                        }
                      >
                        เพิ่ม
                      </Button>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </>
    );
  };

  const handleDetail = () => {
    const solveOptions = [
      { key: 1, value: "1", text: "เข้าซ่อมหน้างาน" },
      { key: 2, value: "2", text: "ลูกค้าสั่งซื้ออะไหล่ซ่อมด้วยตนเอง" },
    ];
    return (
      <Segment>
        <table className="handleDetail">
          <tbody>
            <tr>
              <td>
                <label>
                  ปัญหาแจ้งซ่อม <span style={{ color: "#ff0000" }}>*</span>
                </label>
              </td>
              <td>
                <Form>
                  <Form.Field>
                    <Select
                      options={problemOptions}
                      placeholder="ปัญหาแจ้งซ่อม"
                      value={maintenanceDetail?.topic}
                      onChange={(e, { value }) =>
                        setMaintenanceDetail({
                          ...maintenanceDetail,
                          topic: value,
                        })
                      }
                    />
                  </Form.Field>
                </Form>
              </td>
            </tr>
            <tr>
              <td>
                วิธีการแก้ไข<span style={{ color: "#ff0000" }}>*</span>
              </td>
              <td>
                <Form>
                  <input
                    type="text"
                    placeholder="วิธีการแก้ไข"
                    value={maintenanceDetail?.handleNote || ""}
                    onChange={(e) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        handleNote: e.target.value,
                      })
                    }
                  />
                </Form>
              </td>
            </tr>
            <tr>
              <td>
                วันที่ทำการแก้ไข<span style={{ color: "#ff0000" }}>*</span>
              </td>
              <td>
                <Form>
                  <SemanticDatepicker
                    placeholder="วันที่ทำการแก้ไข"
                    format="DD-MM-YYYY"
                    value={
                      maintenanceDetail?.handleDate
                        ? new Date(maintenanceDetail?.handleDate)
                        : null
                    }
                    onChange={(e, { value }) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        handleDate: onUpdateTime(value),
                      })
                    }
                  />
                </Form>
              </td>
            </tr>
            <tr>
              <td>
                ชื่อผู้รับผิดชอบ<span style={{ color: "#ff0000" }}>*</span>
              </td>
              <td>
                <Table celled className="pic">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>ชื่อผู้รับผิดชอบ</Table.HeaderCell>
                      <Table.HeaderCell>สถานะ</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {pic?.map((eng, idx) => (
                      <Table.Row key={idx}>
                        <Table.Cell>
                          <Form>
                            <input
                              type="text"
                              placeholder="ชื่อผู้รับผิดชอบ"
                              value={eng?.name || ""}
                              readOnly={users.userDetail?.role !== "manager"}
                              onChange={(e) => {
                                let newPartUse = pic;
                                newPartUse[idx]["name"] = e.target.value;
                                setPic([...newPartUse]);
                              }}
                            />
                          </Form>
                        </Table.Cell>
                        <Table.Cell>
                          {idx ? (
                            <Button
                              color="red"
                              onClick={() => {
                                console.log(idx);
                                let newPartUse = pic;
                                newPartUse.splice(idx, 1);
                                setPic([...newPartUse]);
                              }}
                            >
                              ลบ
                            </Button>

                          ) : (
                            <Button
                              color="teal"
                              disabled={users.userDetail?.role !== "manager"}
                              onClick={() =>
                                pic?.length < 3
                                  ? setPic([...pic, { name: "" }])
                                  : alertDialog(
                                      "Error!",
                                      "เพิ่มผู้รับผิดชอบได้ไม่เกิน 3 คน",
                                      "error"
                                    )
                              }
                            >
                              เพิ่ม
                            </Button>
                          )}
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </td>
            </tr>
            
            <tr>
              <td>
                จังหวัดที่แก้ไข<span style={{ color: "#ff0000" }}>*</span>
              </td>
              <td>
                <Form>
                  <Select
                    options={province}
                    placeholder="จังหวัดที่แก้ไข"
                    search
                    value={maintenanceDetail?.provinceId}
                    onChange={(e, { value }) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        provinceId: value,
                      })
                    }
                  />
                </Form>
              </td>
            </tr>
            <tr>
              <td>อะไหล่สิ้นเปลือง(CLPT)</td>
              <td>{createPartUse()}</td>
            </tr>             
            <tr>
              <td>อะไหล่ที่ใช้เพิ่มเติม(CLPE)</td>
              <td>{createAdditionalPart()}</td>
            </tr>
            <tr>
              <td>ราคารวมอะไหล่</td>
              <td>
                <Form>
                  <input
                    type="text"
                    placeholder={"ราคารวมอะไหล่ (บาท)"}
                    value={`${handleGetCost().toLocaleString()} บาท`}
                    readOnly
                  />
                </Form>
              </td>
            </tr>
            <tr>
              <td>วิธีการซ่อม</td>
              <td>
                <Form>
                  <Select
                    options={solveOptions}
                    placeholder="วิธีการซ่อม"
                    search
                    value={maintenanceDetail?.handleRemark || ""}
                    onChange={(e, { value }) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        handleRemark: value,
                      })
                    }
                  />
                </Form>
                {/* <Form>
                  <TextArea
                    type="text"
                    placeholder="หมายเหตุ"
                    value={maintenanceDetail?.handleRemark || ""}
                    onChange={(e) =>
                      setMaintenanceDetail({
                        ...maintenanceDetail,
                        handleRemark: e.target.value,
                      })
                    }
                  />
                </Form> */}
              </td>
            </tr>
          </tbody>
        </table>
        {createHandleImage()}
      </Segment>
    );
  };

  const createHandleImage = () => {
    return (
      <>
        <Divider horizontal>
          <Header as="h4">
            <Icon name="images" />
            การแก้ไข ({maintenanceImage?.length}/5)
          </Header>
        </Divider>

        <div className="images">
          <input type="file" multiple onChange={onSelectImage} />
        </div>
        <div className="addMaintenance">
          {maintenanceImage?.length > 0 &&
            maintenanceImage.map((image, idx) => (
              <div key={idx} className="fadein">
                <div onClick={() => removeImage(image.name)} className="delete">
                  <Icon name="times circle" size="large" />
                </div>
                {image?.name && (
                  <img
                    key={`${image.name}-${idx}`}
                    alt="add-maintenance"
                    src={URL.createObjectURL(image)}
                    style={{
                      width: 300,
                      height: 300,
                      objectFit: "cover",
                    }}
                  />
                )}
                {image.path && (
                  <img
                    key={idx}
                    alt="add-maintenance"
                    src={`${END_POINT}/get/image?name=${image.path}`}
                    style={{
                      width: 300,
                      height: 300,
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
            ))}
        </div>
      </>
    );
  };

  const createButton = () => {
    return (
      <>
        {users.userDetail?.role !== "sc" && (
          <Button color="teal" onClick={() => onUpdateMaintenance("save")}>
            <Icon name="save outline" />
            บันทึก
          </Button>
        )}
        &emsp;
        {users.userDetail?.role === "manager" && (
          <>
            <Button
              basic
              color="green"
              onClick={() => onUpdateMaintenance("reject")}
            >
              <Icon name="x" />
              ไม่อนุมัติ
            </Button>
            &emsp;
            <Button
              color="olive"
              onClick={() => onUpdateMaintenance("approve")}
            >
              <Icon name="check" />
              อนุมัติ
            </Button>
          </>
        )}
      </>
    );
  };

  return (
    <div className="saReceiveDetail">
      <Sidebar tabActive="saReceived" />
      <Navigation />
      <LetterLoading isOpen={isLoading} />

      <div className="saReceiveDetail-content">
        <h2>Service Admin รับเรื่อง</h2>
        <hr />

        <div className="saReceiveDetail-content-inform">
          {<MaintenanceAdd order={maintenanceDetail} />}
        </div>

        {users.userDetail?.role !== "sc" && (
          <div className="saReceiveDetail-content-handle">
            <Divider horizontal>
             <Header as="h3">
              <Icon name="tag" />
              การแก้ไข
            </Header>
            </Divider>
          {handleDetail()}
          </div>
        )}

        <div className="saReceiveDetail-content-button">{createButton()}</div>

      </div>
    </div>
  );
}
